import {useGetAndSet} from "./useGetAndSet";
import {createSetWorkServiceDataAction} from "../actions/dataActions";


export const useWorkServiceData = (params, dataFresh) => {
    return useGetAndSet("service", params, createSetWorkServiceDataAction, dataFresh);
}